module.exports = __webpack_public_path__ + "img/ablakozas-thumb.0b9a4ab0.jpg";